<div class="section-card">
  <div class="section-card__title">
    {{ title }}
    <div class="d-flex align-items-center justify-content-end">
      <ng-content select="[slot='trailing-icon']"></ng-content>
      @if(enableToggle){
        <ng-container>
          <img src="assets/img/toggle-arrow.svg" alt=""
               [style.transform]="isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'"
               style="transition: transform 0.3s ease;" (click)="toggleSection()" [class.cursor-pointer]="enableToggle">
        </ng-container>
      }
      
    </div>
  </div>
  <div class="section-card__body" [@slideUpDown]="isExpanded ? 'expanded' : 'collapsed'">
    <ng-content></ng-content>
  </div>
</div>
